import { render, staticRenderFns } from "./YldsQianhe.vue?vue&type=template&id=cd61f496&scoped=true"
import script from "./YldsQianhe.vue?vue&type=script&lang=js"
export * from "./YldsQianhe.vue?vue&type=script&lang=js"
import style0 from "./YldsQianhe.vue?vue&type=style&index=0&id=cd61f496&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd61f496",
  null
  
)

export default component.exports